/**
 * Audio Control Accessibility Enhancement
 * Adds keyboard navigation and ARIA support to the existing audioControl component
 */

document.addEventListener('DOMContentLoaded', function() {
    // Wait for the main audioControl component to initialize
    setTimeout(function() {
        const audioControls = document.querySelectorAll('.audio-control');
        
        audioControls.forEach(function(audioControl) {
            // Add keyboard event listener
            audioControl.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    // Trigger the existing jQuery click handler
                    if (window.jQuery) {
                        window.jQuery(audioControl).trigger('click');
                    } else {
                        // Fallback to native click
                        audioControl.click();
                    }
                }
            });
            
            // Update ARIA attributes when state changes
            const updateAriaAttributes = function() {
                const volumeOff = audioControl.querySelector('.volume-off, .audio-control__volume-off');
                const volumeUp = audioControl.querySelector('.volume-up, .audio-control__volume-up');
                
                if (volumeOff && volumeUp) {
                    const isMuted = volumeOff.classList.contains('active');
                    audioControl.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
                    audioControl.setAttribute('aria-label', isMuted ? 'Unmute audio' : 'Mute audio');
                }
            };
            
            // Observe changes to child elements for ARIA updates
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        updateAriaAttributes();
                    }
                });
            });
            
            // Observe changes to volume control elements
            const volumeOff = audioControl.querySelector('.volume-off, .audio-control__volume-off');
            const volumeUp = audioControl.querySelector('.volume-up, .audio-control__volume-up');
            
            if (volumeOff) {
                observer.observe(volumeOff, { attributes: true, attributeFilter: ['class'] });
            }
            if (volumeUp) {
                observer.observe(volumeUp, { attributes: true, attributeFilter: ['class'] });
            }
            
            // Set initial ARIA state
            updateAriaAttributes();
        });
    }, 100); // Small delay to ensure main component is initialized
});